/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageRef = "appointmentOffer" | "botFollowup" | "broadcast" | "chat" | "chatAudit" | "chatAuditTz" | "chatNotification" | "feedback" | "feedbackReminder" | "followup" | "formReminder" | "generic" | "outboundReferralOutreach" | "outboundReferralReminder" | "pinVerification" | "referralFollowup" | "referralRedirect" | "referralReminder" | "reminder" | "reschedule" | "stop" | "telehealth" | "waitingRoomPatient" | "waitlist" | "waitlistOffer" | "%future added value";
export type TypographyMessageRef_Message = {
    readonly ref: EnumMessageRef | null;
    readonly " $refType": "TypographyMessageRef_Message";
};
export type TypographyMessageRef_Message$data = TypographyMessageRef_Message;
export type TypographyMessageRef_Message$key = {
    readonly " $data"?: TypographyMessageRef_Message$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyMessageRef_Message">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyMessageRef_Message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ref",
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
(node as any).hash = '1a57b6028a7e2645d0a346360f2e0865';
export default node;
